// @flow
import type { Dispatch } from "redux";
import { attempt, get } from "lodash";
import mediator from "@tvg/mediator";
import uamServices from "@tvg/api/uam";
import { userSetHandicappingSortModeAction } from "@tvg/shared-actions/ProgramActions";
import { setUserPrefs, failUserPrefs } from "../actions/user";

export const formatPreferences = (preferences: Object) => {
  const formattedPreferences = {};

  preferences.forEach(({ description, metadata }) => {
    formattedPreferences[description] = metadata;
  });

  if (formattedPreferences?.bet_prefs) {
    formattedPreferences.bet_prefs = JSON.parse(formattedPreferences.bet_prefs);
  }

  return formattedPreferences;
};

export const onUserPreferencesError = (
  err: Error,
  defaultPreferences: ?Object,
  dispatch: Dispatch<*>
) => {
  dispatch(failUserPrefs(err));
  mediator.base.dispatch({ type: "USER_PREFS:LOAD_FAIL" });

  if (typeof defaultPreferences === "object") {
    console.warn(
      "[User preferences]: Using default preferences and ignoring user preferences"
    );
    dispatch(setUserPrefs(defaultPreferences, false));
  }
};

export const getUserPreferences = async (
  accountNumber: ?number,
  dispatch: Dispatch<*>,
  defaultPreferences?: Object,
  mixDefaultPreferences: boolean = false
) => {
  try {
    if (!accountNumber) {
      onUserPreferencesError(
        new Error("AccountNumber is required to get user preferences."),
        defaultPreferences,
        dispatch
      );

      return;
    }

    const res = await uamServices.getUserPrefs(accountNumber);
    const preferences = get(res, "data.preferences", []);
    let mappedPreferences = formatPreferences(preferences);

    if (mixDefaultPreferences) {
      mappedPreferences = {
        ...mappedPreferences,
        ...defaultPreferences
      };
    }

    attempt(() =>
      localStorage.setItem(
        "defaultPaymentMethod",
        get(mappedPreferences, `defaultPaymentMethod`, null)
      )
    );

    // load default payment method to storage
    dispatch(setUserPrefs(mappedPreferences, true));

    // load default sort mode
    attempt(() => {
      const sortMode = get(mappedPreferences, "handicappingSortFavoriteMode");
      dispatch(userSetHandicappingSortModeAction(JSON.parse(sortMode).basic));
    });

    mediator.base.dispatch({ type: "USER_PREFS:LOAD_SUCCESS" });
  } catch (err) {
    onUserPreferencesError(err, defaultPreferences, dispatch);
  }
};
